import React, { useEffect, useRef } from 'react';
import { global_var } from '../../services/cs-lab-config';
import IdeHeader from "./ide-header";
import { Button, Space } from 'antd';

const MitAppInventor = () => {
    document.title = "CS Lab | Mit App Inventor";
    const mitAppInventorOpenerRef = useRef(null);

    useEffect(() => {
        mitAppInventorOpenerRef.current = window.open(global_var.MITAPPINVENTOR_ENDPOINT, '_blank');
    
        const handleMessage = (event) => { 
            if (event.data.status === 'mit-ready') {
                if (mitAppInventorOpenerRef.current) {
                    mitAppInventorOpenerRef.current.postMessage({ 
                        status: 'new',
                        username: global_var.user_name, 
                        userLoginId: global_var.user_login_id, 
                        companyLogo: global_var.companyLogo
                    }, '*');
                }
            }
        };
    
        // Add a listener for the postMessage event
        window.addEventListener('message', handleMessage);
    
        // Cleanup the event listener when the component unmounts
        return () => {
            if (mitAppInventorOpenerRef.current) {
                mitAppInventorOpenerRef.current.close();
            }
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <div className="container-fluid p-0">
            <div className="row mt-2">
                <div className="col">
                    <IdeHeader
                        headerName="MIT App Inventor"
                        hidePortfolio={true}
                    />
                    <Space wrap>
                        <Button
                            type={"primary"}
                            style={{ marginRight: "8px" }}
                            onClick={() => {
                                if (mitAppInventorOpenerRef.current) {
                                    mitAppInventorOpenerRef.current.focus();
                                } else {
                                    window.open(global_var.MITAPPINVENTOR_ENDPOINT, '_blank');
                                }
                            }}
                        >
                            Open MIT App
                        </Button>
                    </Space>
                </div>
            </div>
        </div>
    );
};

export default MitAppInventor;
